export const TRADE_IMPORT_ACCEPT = ".xlsx,.csv,.txt,.tsv";

const SUPPORTED_TRADE_IMPORT_EXTENSIONS = new Set([".xlsx", ".csv", ".txt", ".tsv"]);

export function tradeImportExtension(fileName) {
  const normalized = String(fileName ?? "").trim().toLowerCase();
  const dotIndex = normalized.lastIndexOf(".");
  return dotIndex >= 0 ? normalized.slice(dotIndex) : "";
}

export function assertSupportedTradeImportFile(file) {
  const extension = tradeImportExtension(file?.name);
  if (!SUPPORTED_TRADE_IMPORT_EXTENSIONS.has(extension)) {
    throw new Error("仅支持 .xlsx、.csv、.txt、.tsv 交易文件。");
  }
  return extension;
}

export async function readTradeImportText(file) {
  const extension = assertSupportedTradeImportFile(file);
  if (extension === ".xlsx") {
    throw new Error("XLSX 文件需要通过工作表上传接口读取。");
  }
  const buffer = await file.arrayBuffer();
  try {
    return new TextDecoder("utf-8", { fatal: true }).decode(buffer);
  } catch {
    return new TextDecoder("gb18030").decode(buffer);
  }
}
